import React from 'react';

const LogoMark = () => (
  <svg viewBox="0 0 100 100" className="size-10">
    <defs>
      <linearGradient id="logo-grad" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" style={{ stopColor: '#FF2E63' }} />
        <stop offset="100%" style={{ stopColor: '#3C1053' }} />
      </linearGradient>
    </defs>
    <rect width="100" height="100" rx="20" fill="url(#logo-grad)" />
    <path 
      d="M25 35 H65 L45 75 M55 45 H75 M55 60 H75 M70 28 A4 4 0 1 1 70.1 28" 
      stroke="white" 
      strokeWidth="9" 
      fill="none" 
      strokeLinecap="round" 
      strokeLinejoin="round" 
    />
  </svg>
);

interface HeaderProps {
  onNavigate?: (index: number) => void;
  activeIndex?: number;
}

const Header: React.FC<HeaderProps> = ({ onNavigate, activeIndex }) => {
  return (
    <header className="fixed top-0 z-50 w-full px-6 lg:px-12 py-8 flex items-center justify-between mix-blend-difference">
      <div className="flex items-center gap-3 cursor-pointer" onClick={() => onNavigate?.(0)}>
        <LogoMark />
        <h2 className="text-2xl font-black tracking-[0.1em] uppercase italic text-white">T.H.E APPS</h2>
      </div>
      
      <nav className="hidden lg:flex items-center gap-12">
        <a 
          onClick={() => onNavigate?.(1)}
          className={`text-xs font-bold tracking-widest uppercase transition-colors cursor-pointer ${activeIndex === 1 ? 'text-primary' : 'text-white/70 hover:text-primary'}`}
        >
          Work
        </a>
        <a 
          onClick={() => onNavigate?.(2)}
          className={`text-xs font-bold tracking-widest uppercase transition-colors cursor-pointer ${activeIndex === 2 ? 'text-primary' : 'text-white/70 hover:text-primary'}`}
        >
          Studio
        </a>
        <a 
          onClick={() => onNavigate?.(3)}
          className={`text-xs font-bold tracking-widest uppercase transition-colors cursor-pointer ${activeIndex === 3 ? 'text-primary' : 'text-white/70 hover:text-primary'}`}
        >
          Process
        </a>
        <a 
          href="mailto:rob@theapps.io"
          className="bg-primary/20 hover:bg-primary px-6 py-2 border border-primary/30 transition-all text-[10px] font-black tracking-[0.3em] uppercase text-white rounded-full"
        >
          Support: rob@theapps.io
        </a>
      </nav>
      
      <div className="lg:hidden">
        <a href="mailto:rob@theapps.io" className="text-primary material-symbols-outlined text-3xl">mail</a>
      </div>
    </header>
  );
};

export default Header;